import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import { FileText, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';

const SetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    tenantSlug: params.get('tenant') || '',
    token: params.get('token') || '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/set-password', form);
      toast.success('Password set successfully');
      navigate('/login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 backdrop-blur rounded-2xl mb-4 shadow-xl">
            <FileText className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white">Set Password</h1>
          <p className="text-primary-200 mt-1">Activate your organization admin account</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">Organization ID</label>
              <input
                className="input"
                value={form.tenantSlug}
                onChange={e => setForm({ ...form, tenantSlug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '') })}
                required
              />
            </div>
            <div>
              <label className="label">Setup Token</label>
              <input className="input" value={form.token} onChange={e => setForm({ ...form, token: e.target.value })} required />
            </div>
            <div>
              <label className="label">New Password</label>
              <input type="password" className="input" value={form.newPassword} onChange={e => setForm({ ...form, newPassword: e.target.value })} required minLength={8} />
            </div>
            <div>
              <label className="label">Confirm Password</label>
              <input type="password" className="input" value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })} required minLength={8} />
            </div>
            <button type="submit" disabled={loading} className="w-full btn-primary justify-center disabled:opacity-60">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              {loading ? 'Saving...' : 'Set Password'}
            </button>
          </form>
          <Link to="/login" className="block text-center text-sm text-primary-600 hover:underline mt-4">Back to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
